import { render, staticRenderFns } from "./EditGallery.vue?vue&type=template&id=6ff1023b&scoped=true"
import script from "./EditGallery.vue?vue&type=script&lang=js"
export * from "./EditGallery.vue?vue&type=script&lang=js"
import style0 from "./EditGallery.vue?vue&type=style&index=0&id=6ff1023b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff1023b",
  null
  
)

export default component.exports